define(function(require) {
    return {
        LAYER_ID : "SERVICE_AREAS",
        LAYER_TYPE : "POLYGON",
        LOADING_MODE : "ON_DEMAND",
        USE_TYPED_ARRAY : true,
        INDEX : 28,
        DATATABLE_ID : "t_SERVICE_AREAS",
        FIELDS : [
            {ID : "ID", NAME : "Id", DATA_TYPE: "STRING", VALUE: "{{ID}}"},
            {ID : "NAME", NAME : "Nom", DATA_TYPE: "STRING", VALUE: "{{NAME}}"},
            {ID : "FROM_BREAK", NAME : "De la borne", DATA_TYPE: "NUMBER", VALUE: "{{FROM_BREAK}}"},
            {ID : "TO_BREAK", NAME : "À la borne", DATA_TYPE: "NUMBER", VALUE: "{{TO_BREAK}}"},
            {ID : "UNIT", NAME : "Unité", DATA_TYPE: "STRING", VALUE: "{{UNIT}}"}
        ],
        STYLES : [
            {
                ID : "s_Default",
                SYMBOLIZERS : [
                    {
                        SYMBOLIZER_TYPE : "PolygonSymbolizer",
                        FILL_COLOR_1 : "RANDOM",
                        FILL_STYLE : "SOLID",
                        STROKE_COLOR : "rgba(130,130,130,1)",
                        STROKE_STYLE : "LINE",
                        STROKE_WIDTH : "1"
                    }
                ],
                STYLE_LABEL_PROPERTIES : {
                    BOLD : true,
                    COLOR : "rgba(0,0,0,1)",
                    FONT_NAME : "Arimo-Regular",
                    FONT_FILE_SOURCE : "fonts/externals/Arimo-Regular",
                    HALO_COLOR : "rgba(255,255,255,1)",
                    HAS_HALO_COLOR : true,
                    SIZE : 8
                }
            }
        ],
        LAYER_PROPERTIES : {
            NAME : "Zones de desserte",
            FEATURE_ID_DATACOLUMN : "ID",
            UNIQUE_FEATURES_STYLES : true,
            BLEND_MODE : "MULTIPLY",
            FEATURE_NAME_DATACOLUMN : "NAME",
            DATATIP_DATACOLUMNS : ["NAME"],
            DATATIP_DATACOLUMNS_DISPLAY_MODE : "NONE",
            DATAVIEW_DATACOLUMNS : ["NAME", "FROM_BREAK", "TO_BREAK", "UNIT"],
            DATAVIEW_DATACOLUMNS_DISPLAY_MODE : "NONE",
            INFOVIEW_DATACOLUMNS : ["NAME", "FROM_BREAK", "TO_BREAK", "UNIT"],
            INFOVIEW_DATACOLUMN_DISPLAY_MODE : "NONE",
            //SEARCHABLE_DATACOLUMNS : ["NAME"],
            IS_VISIBLE_IN_LAYER_CONTROL : true,
            IS_VISIBLE_IN_LEGEND : false,
            SHOW_STYLES_IN_LAYER_CONTROL : false,
            LABEL_DATACOLUMN : "NAME",
            VISIBLE : true,
            LABEL_PROPERTIES : {
                ALLOW_LABEL_DUPLICATES : true,
                LEADER_LINES : false,
                POSITION : "MIDDLE-CENTER",
                PRIORITY : 10,
                VISIBLE : false
            }
        }
    };
});
